export default __webpack_public_path__ + "locales/de/Article.json?hash=40e14943513281c23836859a329562aa";